<template>
    <div>
        <top-nav-landing></top-nav-landing>

        <main id="main">
            <template v-for="(block, key) in pageContent">
                <section class="intro-general landing-section" id="intro" v-if="key === 'section1'">
                    <div class="container">
                        <div v-html="block.content"></div>
                    </div>
                </section>

                <section class="about landing-section" id="about" v-if="key === 'section2'">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-12 col-md-10 col-lg-8">
                                <div v-html="block.content"></div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="process landing-section" id="process" v-if="key === 'section3'">
                    <div class="container">
                        <div class="row">
                            <div v-html="block.content"></div>
                        </div>
                    </div>
                </section>

                <section class="faq landing-section" v-if="key === 'section4'">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div v-html="block.content"></div>
                        </div>
                    </div>
                </section>

            </template>
        </main>

        <div v-html="footer"></div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {url} from '../mixins/url';

    export default {
        name: 'staticPages',
        mixins: [url],
        data() {
            return {
                footer: null,
                pageContent: null,
                lang: this.$i18n.locale,
                apiPrefix: process.env.MIX_APP_PAGES_URL + '/api/'
            };
        },

        created() {
            this.getPageContent();
        },

        watch: {
            $route(to, from, next) {
                if (to.name === 'homepage' || to.name === 'static') {
                    return this.getPageContent();
                }

                next();
            }
        },

        methods: {
            getPageContent() {
                let name = this.$route.name;
                if (this.$route.params.pathMatch) {
                    name = this.$route.params.pathMatch.replace(this.$i18n.locale + '/', '');
                }
                axios({
                    url: this.apiPrefix + _.camelCase(name),
                    transformRequest: [function (data, headers) {
                        delete headers.common.Accept;
                        delete headers.common['X-Requested-With'];

                        return data;
                    }]
                }).then(response => {
                    this.footer = response.data.footer;
                    this.pageContent = response.data.pageStructure;
                    this.handleUrlHash();
                }).catch(error => {
                    this.$router.push({name: 'PageNotFound'});
                });
            }
        }
    }
</script>
